import { styled } from "@mui/material";
import Chip, { ChipProps as MuiTagProps } from "@mui/material/Chip";

interface StyledTagProps extends Omit<MuiTagProps, "size"> {
  tagSize: "big" | "small";
  isDelete?: (event: any) => void;
  isError?: boolean;
}

export const StyledTag = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "tagSize" && prop !== "isError",
})<StyledTagProps>`
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  border-radius: ${(props) => props.theme.wsc.radius.sm};
  background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  font-size: ${(props) => props.theme.wsc.typography.body3.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body3.fontWeight};

  ${(props) =>
    props.tagSize === "small" &&
    `
    height: 1.05rem;
    padding: ${
      props.isDelete
        ? `0 0 0 ${props.theme.wsc.spacing[0]}`
        : `0 ${props.theme.wsc.spacing[0]}`
    };
  `};

  ${(props) =>
    props.tagSize === "big" &&
    `
    gap: 4px;
    height: 1.5rem;
    padding: ${
      props.isDelete
        ? `0 ${props.theme.wsc.spacing[1]}`
        : `${props.theme.wsc.spacing[1]}`
    };
  `};

  .MuiChip-label {
    padding: 0;
  }

  .MuiButtonBase-root {
    padding: 0;
    margin: 0;
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &:hover {
      color: ${(props) => props.theme.wsc.palette.neutral[100]};
    }
  }

  &:hover {
    background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
  }

  &.Mui-disabled {
    opacity: 1;
    background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    color: ${(props) => props.theme.wsc.palette.neutral[300]};

    button {
      color: ${(props) => props.theme.wsc.palette.neutral[300]};
    }
  }

  ${(props) =>
    props.isError &&
    `
    background-color: ${props.theme.wsc.palette.warning[100]};

    &:hover {
        background-color: ${props.theme.wsc.palette.warning[100]};
    };
  `};
`;
